var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamBuild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.15V11.8C14.5 10.5419 13.6395 9.48479 12.475 9.18506M10.1125 1.19626C11.102 1.5968 11.8 2.56688 11.8 3.7C11.8 4.83311 11.102 5.8032 10.1125 6.20374M11.125 13.15C11.125 11.892 11.125 11.2629 10.9195 10.7668C10.6454 10.1052 10.1198 9.57956 9.45824 9.30552C8.96206 9.1 8.33304 9.1 7.075 9.1H5.05C3.79196 9.1 3.16294 9.1 2.66675 9.30552C2.00518 9.57956 1.47956 10.1052 1.20553 10.7668C1 11.2629 1 11.892 1 13.15M8.7625 3.7C8.7625 5.19117 7.55367 6.4 6.0625 6.4C4.57133 6.4 3.3625 5.19117 3.3625 3.7C3.3625 2.20883 4.57133 1 6.0625 1C7.55367 1 8.7625 2.20883 8.7625 3.7Z",
    stroke: "#25324B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBuild);
export default __webpack_public_path__ + "static/media/team-build.7e4562c4f17ba9fa099c120d5d0abd71.svg";
export { ForwardRef as ReactComponent };